// extracted by mini-css-extract-plugin
export default {"wrap":"SurveyMultipleAnswer_wrap__4DcOj","empty":"SurveyMultipleAnswer_empty__fKE2+","answer":"SurveyMultipleAnswer_answer__-Dihj"};